import { CompanyService } from './companyServices';
import { Image } from './images';
import { ItemGroupConfiguration } from './itemGroupConfigurations';
import { ItemIdentifier } from './itemIdentifiers';
import { ItemTraceabilityGroup } from './itemTraceabilityGroups';
import { Listing } from './listings';
import { WarehouseLocation } from './locations';
import { ProductionFormula } from './productionFormulas';
import { Stock } from './stock';
import { Tag } from './tags';

export type ProductUuid = string;

export type CustomLabelPrinterType = 'barcode' | 'shipping' | 'paper';

export interface ItemCustomLabel {
    name: string
    url: string
    printerType: CustomLabelPrinterType
}

export interface ItemHistory {
    date: string
    type: string
    id: number | string
    quantity: number
    stockStatus: 'complete' | 'inbound' | 'allocated'
    completedDate: string | null
}

export const itemConditions = [
    'new',
    'new_oem',
    'new_with_warranty',
    'new_open_box',
    'used_like_new',
    'used_very_good',
    'used_good',
    'used_acceptable',
    'used_poor',
    'collectible_like_new',
    'collectible_very_good',
    'collectible_good',
    'collectible_acceptable',
    'collectible_poor',
    'used_refurbished',
    'refurbished',
    'unsellable',
] as const;
export type ItemConditionEnum = typeof itemConditions[number];

export const itemConditionTypes = [
    'new',
    'used',
    'collectible',
    'refurbished',
] as const;
export type ItemConditionTypeEnum = typeof itemConditionTypes[number];

export interface Item<
    TG extends ItemTraceabilityGroup | undefined = any, // eslint-disable-line @typescript-eslint/no-explicit-any -- generic default requires any; unknown breaks structural assignability for optional type parameters
> {
    id: number
    uuid: ProductUuid
    merchantId: number
    listings?: Listing[]
    title: string
    merchantSku: string
    images: Image[]
    customLabel?: ItemCustomLabel | null
    identifiers: ItemIdentifier[]
    searchableIdentifiers: string
    itemGroupConfigurations: ItemGroupConfiguration[]
    traceabilityGroups: TG extends ItemTraceabilityGroup ? Array<TG> : undefined
    companyServices: CompanyService[]
    prepInstructions: string[]
    costPerItem?: number
    quantityInStock?: number | null
    history?: ItemHistory[]
    weightGm?: number | null
    lengthMm?: number | null
    widthMm?: number | null
    heightMm?: number | null
    areDimensionsLocked: boolean | null
    condition: ItemConditionEnum | null
    conditionNote?: string | null
    deletedAt?: string | null
    availableQuantity?: number | null
    unavailableQuantity?: number | null
    allocatedQuantity?: number | null
    inboundQuantity?: number | null
    searchableTags: string[]
    tags?: Tag[]
    stocks?: Array<Stock<WarehouseLocation, undefined>>
    productionFormulas?: ProductionFormula[]
}
